var _defs, _g, _g2, _g3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    zoomAndPan: "magnify",
    viewBox: "0 0 60 52.499999",
    height: 60,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a73f0021af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.28125 4.53125 L 22 4.53125 L 22 26 L 0.28125 26 Z M 0.28125 4.53125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3c2dda6362"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 4.53125 L 58.972656 4.53125 L 58.972656 26 L 21 26 Z M 21 4.53125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "08f75c96cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.28125 25 L 58.972656 25 L 58.972656 46.878906 L 0.28125 46.878906 Z M 0.28125 25 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a73f0021af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f429b",
    d: "M 21.476562 4.539062 L 6.804688 4.539062 C 3.203125 4.539062 0.28125 7.453125 0.28125 11.050781 L 0.28125 25.707031 L 21.476562 25.707031 Z M 13.875 19.667969 L 10.808594 17.441406 L 7.738281 19.667969 L 8.910156 16.066406 L 5.84375 13.839844 L 9.632812 13.839844 L 10.808594 10.238281 L 11.980469 13.839844 L 15.769531 13.839844 L 12.703125 16.066406 Z M 13.875 19.667969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3c2dda6362)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eeeeee",
    d: "M 52.453125 4.539062 L 21.476562 4.539062 L 21.476562 25.707031 L 58.972656 25.707031 L 58.972656 11.050781 C 58.972656 7.453125 56.054688 4.539062 52.453125 4.539062 Z M 52.453125 4.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#08f75c96cd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d42d27",
    d: "M 0.28125 25.707031 L 0.28125 40.359375 C 0.28125 43.957031 3.203125 46.871094 6.804688 46.871094 L 52.453125 46.871094 C 56.054688 46.871094 58.972656 43.957031 58.972656 40.359375 L 58.972656 25.707031 Z M 0.28125 25.707031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 11.980469 13.839844 L 10.808594 10.238281 L 9.632812 13.839844 L 5.84375 13.839844 L 8.910156 16.066406 L 7.738281 19.667969 L 10.808594 17.441406 L 13.875 19.667969 L 12.703125 16.066406 L 15.769531 13.839844 Z M 11.980469 13.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChile);
export default __webpack_public_path__ + "static/media/chile.d1149ea1ccce840413061a6cc14e0132.svg";
export { ForwardRef as ReactComponent };